
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  DrylusProvider,
  ThemeProvider,
  AlertsProvider,
} from '@drawbotics/react-drylus';
import Playground, { PropsTable } from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Providers`}</h1>
<p>{`Providers are components that `}<em parentName="p">{`provide`}</em>{` basic functionality throughout the whole application that uses the design system. You can find more information about each one individually in the `}<inlineCode parentName="p">{`Components`}</inlineCode>{` section of this styleguide. The available providers are:`}</p>
<h3>{`Drylus Provider`}</h3>
<p>{`Combines all the providers into one for easier usage and avoiding having to repeat the same code in multiple projects.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { DrylusProvider } from '@drawbotics/react-drylus';
`}</code></pre>
<Playground __position={0} __code={`<DrylusProvider>
  Content within provider
</DrylusProvider>`} component={DrylusProvider} mdxType="Playground">
  <DrylusProvider mdxType="DrylusProvider">
    Content within provider
  </DrylusProvider>
</Playground>
<h3>{`Theme Provider`}</h3>
<p>{`Wraps the whole application with the required styles. Normalizes and applies default styles globally (note that each component styles itself).`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ThemeProvider } from '@drawbotics/react-drylus';
`}</code></pre>
<PropsTable component={ThemeProvider} mdxType="PropsTable" />
<h3>{`AlertsProvider`}</h3>
<p>{`See `}<a parentName="p" {...{
        "href": "/component-kit/components/alerts"
      }}><inlineCode parentName="a">{`Alerts`}</inlineCode></a>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { AlertsProvider } from '@drawbotics/react-drylus';
`}</code></pre>
<PropsTable component={AlertsProvider} mdxType="PropsTable" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;